import { render } from "./AdminSection.vue?vue&type=template&id=0a76bec1"
import script from "./AdminSection.vue?vue&type=script&lang=js"
export * from "./AdminSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__